import COMMON_LABELS from "../../../../common/locale/ru_RU";

export const LABELS: Record<string, string> = {
    ...COMMON_LABELS,
};

export default LABELS;
